import {MouseEvent, useCallback} from "react";
import {useAppSelector} from "@/lib/hooks";
import {useIssueAppLoginCodeMutation} from "@/lib/api/auth/accountApi";
import {startApkDownload} from "@/lib/utils/apkDownload";

/**
 * Click handler for an APK download link (AC-902/AC-904): cancels the plain
 * `href` navigation and downloads through apk-service with the partner mark
 * (`click` + `traffic` from localStorage). A signed-in player also gets the AC-903
 * one-time login code, so the app opens signed in; if the code cannot be
 * obtained the download still starts.
 */
export function useApkDownload() {
    const userId = useAppSelector(state => state.auth.userId);
    const [issueAppLoginCode] = useIssueAppLoginCodeMutation();

    return useCallback(async (event?: MouseEvent) => {
        event?.preventDefault();
        let loginCode: string | undefined;
        if (userId) {
            try {
                loginCode = (await issueAppLoginCode().unwrap()).code;
            } catch {
                loginCode = undefined;
            }
        }
        startApkDownload(loginCode);
    }, [userId, issueAppLoginCode]);
}
